<template>
    <v-container class="display-cardapio">
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>

                

                
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><router-link to="/" class="voltar"><img class="imgVoltar" :src="imgVoltar"></router-link>Cardápio</v-toolbar-title>
                        <v-btn v-if="perfil == 2 || perfil == 3" @click="editarCardapio" outline color="white"  style="position:absolute; right:20px; top:7px">Editar</v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>


                            <template>
                                <div>
                                    <v-card class="elevation-1">
                                        <v-layout row wrap>
                                            <v-expansion-panel
                                                expand
                                                v-model="panels"
                                            >
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Segunda-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor v-model="segCafeManha" disabled="true"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Terça-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>
                                                            
                                                            <vue-editor v-model="terCafeManha" disabled="true"></vue-editor>
                                                            
                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Quarta-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>

                                                            <vue-editor v-model="quaCafeManha" disabled="true"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Quinta-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>

                                                            <vue-editor v-model="quiCafeManha" disabled="true"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Sexta-feira
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>

                                                            <vue-editor v-model="sexCafeManha" disabled="true"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Sábado
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>

                                                            <vue-editor v-model="sabCafeManha" disabled="true"></vue-editor>

                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                                <v-expansion-panel-content>
                                                    <div slot="header">
                                                        Domingo
                                                    </div>
                                                    <v-card>
                                                        <v-card-text>

                                                            <vue-editor name="domCafeManha" label="Café da manhã" v-model="domCafeManha" disabled="true"></vue-editor>
                                                            
                                                        </v-card-text>
                                                    </v-card>
                                                    
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>        
                                        </v-layout>       
                                    </v-card>
                                </div>
                            </template><br />
                            <b v-if="observacao != ''">Observação</b><br />
                            <p v-if="observacao != ''">{{observacao}}</p>
                            
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties } from '@/global.js'
import { userInfo } from 'os';

import axios from 'axios'
import VueAxios from 'vue-axios'

import imgVoltar from '../assets/ic-voltar.png';

import { VueEditor } from "vue2-editor"; // https://www.vuetoolbox.com/projects/vue2-editor

//Vue.use(VueAxios, axios)

export default {
    name: 'Display-Cardapio',
    directives: {mask},
    components: {
        VueEditor
    },
    data: vm => ({
        imgVoltar: imgVoltar,
        valid: false,
        texto: null,
        link: null,
        dialog: false,
        loading: false,
        slug: null,
        statusUpload: true,
        tituloModal: "Cardapio atualizado com sucesso!",
        preview: false,
        pushIDs: null,
        push: false,
        textoPush: null,
        urlImg: null,

        segCafeManha: null,
        //segAlmoco: null,
        //segCafeTarde: null,
        //segJanta: null,
        terCafeManha: null,
        //terAlmoco: null,
        //terCafeTarde: null,
        //terJanta: null,
        quaCafeManha: null,
        //quaAlmoco: null,
        //quaCafeTarde: null,
        //quaJanta: null,
        quiCafeManha: null,
        //quiAlmoco: null,
        //quiCafeTarde: null,
        //quiJanta: null,
        sexCafeManha: null,
        //sexAlmoco: null,
        //sexCafeTarde: null,
        //sexJanta: null,
        sabCafeManha: null,
        //sabAlmoco: null,
        //sabCafeTarde: null,
        //sabJanta: null,
        domCafeManha: null,
        //domAlmoco: null,
        //domCafeTarde: null,
        //domJanta: null,
        observacao: null,

        panels: [false, false, false, false, false, false, false],

        perfil: null
        
    }),
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        editarCardapio(){
            this.$router.push(`/editar-cardapio?&escolaID=`+userProperties.escolaID);
        },
        closeModal(){
            this.$router.push(`/display-cardapio`);
        },        
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        criarDocumento(){
            db.collection('cardapio').add({
                
                escolaID: userProperties.escolaID,
                segCafeManha: "Digite seu texto aqui",
                //segAlmoco: "Digite seu texto aqui",
                //segCafeTarde: "Digite seu texto aqui",
                //segJanta: "Digite seu texto aqui",
                terCafeManha: "Digite seu texto aqui",
                //terAlmoco: "Digite seu texto aqui",
                //terCafeTarde: "Digite seu texto aqui",
                //terJanta: "Digite seu texto aqui",
                quaCafeManha: "Digite seu texto aqui",
                //quaAlmoco: "Digite seu texto aqui",
                //quaCafeTarde: "Digite seu texto aqui",
                //quaJanta: "Digite seu texto aqui",
                quiCafeManha: "Digite seu texto aqui",
                //quiAlmoco: "Digite seu texto aqui",
                //quiCafeTarde: "Digite seu texto aqui",
                //quiJanta: "Digite seu texto aqui",
                sexCafeManha: "Digite seu texto aqui",
                //sexAlmoco: "Digite seu texto aqui",
                //sexCafeTarde: "Digite seu texto aqui",
                //sexJanta: "Digite seu texto aqui",
                sabCafeManha: "Digite seu texto aqui",
                //sabAlmoco: "Digite seu texto aqui",
                //sabCafeTarde: "Digite seu texto aqui",
                //sabJanta: "Digite seu texto aqui",
                domCafeManha: "Digite seu texto aqui",
                //domAlmoco: "Digite seu texto aqui",
                //domCafeTarde: "Digite seu texto aqui",
                //domJanta: "Digite seu texto aqui",
                observacao: "Digite seu texto aqui",

                push: false,
                textoPush: null
                
            })
            .then(docRef => {
                console.log('Document written with ID: ', docRef.id);
                this.$router.push(`/`)
                this.loading = false
                this.dialog = true
                
            })
            .catch(function (error) {
                this.loading = false
                console.log('Error adding document: ', error);
                console.log("Erro no envio dos dados. Tente novamente mais tarde!")
            })
        }
        
        
    },
    mounted() {
        const slug = this.generateUUID()
        this.slug = slug;

        this.perfil = userProperties.perfil;

        db.collection('cardapio').where("escolaID", "==", userProperties.escolaID)
        .get()
        .then((querySnapshot) => {
            if(querySnapshot.size != 0){
                querySnapshot.forEach(doc => {
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, " => ", doc.data());               
                    let customObj = doc.data()

                    this.segCafeManha = customObj.segCafeManha,
                    //this.segAlmoco = customObj.segAlmoco,
                    //this.segCafeTarde = customObj.segCafeTarde,
                    //this.segJanta = customObj.segJanta,
                    this.terCafeManha = customObj.terCafeManha,
                    //this.terAlmoco = customObj.terAlmoco,
                    //this.terCafeTarde = customObj.terCafeTarde,
                    //this.terJanta = customObj.terJanta,
                    this.quaCafeManha = customObj.quaCafeManha,
                    //this.quaAlmoco = customObj.quaAlmoco,
                    //this.quaCafeTarde = customObj.quaCafeTarde,
                    //this.quaJanta = customObj.quaJanta,
                    this.quiCafeManha = customObj.quiCafeManha,
                    //this.quiAlmoco = customObj.quiAlmoco,
                    //this.quiCafeTarde = customObj.quiCafeTarde,
                    //this.quiJanta = customObj.quiJanta,
                    this.sexCafeManha = customObj.sexCafeManha,
                    //this.sexAlmoco = customObj.sexAlmoco,
                    //this.sexCafeTarde = customObj.sexCafeTarde,
                    //this.sexJanta = customObj.sexJanta,
                    this.sabCafeManha = customObj.sabCafeManha,
                    //this.sabAlmoco = customObj.sabAlmoco,
                    //this.sabCafeTarde = customObj.sabCafeTarde,
                    //this.sabJanta = customObj.sabJanta,
                    this.domCafeManha = customObj.domCafeManha,
                    //this.domAlmoco = customObj.domAlmoco,
                    //this.domCafeTarde = customObj.domCafeTarde,
                    //this.domJanta = customObj.domJanta,
                    this.observacao = customObj.observacao,

                    this.push = customObj.push,
                    this.textoPush = customObj.textoPush
                })
            }
            else{
                this.criarDocumento();
            }
            

            
            this.loading = false;

        });

        var semana = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado"];
        semana = ["1", "2", "3", "4", "5", "6", "7"];

        var d = new Date();

        if(semana[d.getDay()] == 1){
            this.panels = [false, false, false, false, false, false, true]
        }
        else if(semana[d.getDay()] == 2){
            this.panels = [true, false, false, false, false, false, false]
        }
        else if(semana[d.getDay()] == 3){
            this.panels = [false, true, false, false, false, false, false]
        }
        else if(semana[d.getDay()] == 4){
            this.panels = [false, false, true, false, false, false, false]
        }
        else if(semana[d.getDay()] == 5){
            this.panels = [false, false, false, true, false, false, false]
        }
        else if(semana[d.getDay()] == 6){
            this.panels = [false, false, false, false, true, false, false]
        }
        else if(semana[d.getDay()] == 7){
            this.panels = [false, false, false, false, false, true, true]
        }

        //this.panels = [false, false, false, false, false, false, false]
        
        
    }
};
</script>

<style>
    .display-cardapio .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }
    
    .display-cardapio .v-expansion-panel .v-card.v-sheet.theme--light{
        background: #f7f7f7 !important
    }

    .display-cardapio .container{
        padding: 0 !important
    }

    .display-cardapio #quill-container, .ql-editor{
        height: auto !important;
    }

    .display-cardapio .ql-toolbar.ql-snow{
        display: none !important;
    }

    .display-cardapio .ql-editor{
        padding: 0 !important;
    }

    .display-cardapio #quill-container{
        border: 0;
    }

    
</style>
